import ajax from "../utils/request";

const transApi = {
  /********************************充值订单管理列表*********************************** */
  // 请求充值订单列表
  getOrderList(params) {
    return ajax({
      url: "/recharge/order/list",
      type: "get",
      params: params,
    });
  },
  // 编辑状态说明
  editStatusText(params) {
    return ajax({
      url: "/recharge/order/update",
      type: "post",
      params: params,
    });
  },
  // 把订单信息通知到第三方平台
  handAddScore(params) {
    return ajax({
      url: "/daichong/order/handScore",
      type: "post",
      params: params,
    });
  },
  /********************************提现订单管理列表*********************************** */
  // 请求提现列表
  getWithdrawList(params) {
    return ajax({
      url: "/withdraw/list",
      type: "get",
      params: params,
    });
  },
  // 提现审核
  WithdrawExamine(params) {
    return ajax({
      url: "/withdraw/check",
      type: "post",
      params: params,
    });
  },
  // usdt提现审核
  usdtWithdrawExamine(params) {
    return ajax({
      url: "/withdraw/usdt",
      type: "post",
      params: params,
    });
  },
  /********************************AI交易列表*********************************** */
  // 请求AI交易列表
  getAiTransList(params) {
    return ajax({
      url: "/ai/undress/list",
      type: "get",
      params: params,
    });
  },
  // AI交易审核
  aiTransExamine(params) {
    return ajax({
      url: "/ai/undress/update",
      type: "post",
      params: params,
    });
  },
  /********************************AI图片换脸交易列表*********************************** */
  // 请求AI图片换脸交易列表
  getAiImgTransList(params) {
    return ajax({
      url: "/ai/change_face_img/list",
      type: "get",
      params: params,
    });
  },
  // AI图片换脸交易审核
  aiImgTransExamine(params) {
    return ajax({
      url: "/ai/change_face_img/update",
      type: "post",
      params: params,
    });
  },
  /********************************AI换脸模版*********************************** */
  // 获取AI换脸模版列表
  getChangeFaceModList(params) {
    return ajax({
      url: "/ai/changeface/mod/list",
      type: "get",
      params: params,
    });
  },
  // 添加AI换脸模版
  addChangeFaceMod(params) {
    return ajax({
      url: "/ai/changeface/mod/add",
      type: "post",
      params: params,
    });
  },
  // 修改AI换脸模版
  updateChangeFaceMod(params) {
    return ajax(
      {
        url: "/ai/changeface/mod/update",
        type: "post",
        params: params,
      },
      true
    );
  },
  // 获取AI换脸交易列表
  getChangeFaceList(params) {
    return ajax({
      url: "/ai/changeface/list",
      type: "get",
      params: params,
    });
  },
  // 编辑AI换脸交易列表
  updChangeFaceList(params) {
    return ajax({
      url: "/ai/changeface/update",
      type: "post",
      params: params,
    });
  },
  // 给用户添加AI换脸折扣券
  addUserAiChangeFaceDiscount(params) {
    return ajax({
      url: "/user/generate/aiChangeFaceDiscount",
      type: "post",
      params: params,
    });
  },
  // 查询AI换脸折扣券奖品列表
  getAiChangeFaceDiscountList() {
    return ajax({
      url: "/user/gainAiPrize",
      type: "get",
    });
  },
  /********************************提现方式*********************************** */
  // 新增提现方式
  addWChannel(params) {
    return ajax({
      url: "/withdraw/channel/add",
      type: "post",
      params: params,
    });
  },
  // 获取提现方式配置列表
  getWChannelList(params) {
    return ajax({
      url: "/withdraw/channel/list",
      type: "get",
      params: params,
    });
  },
  // 修改提现方式配置
  updateWChannel(params) {
    return ajax({
      url: "/withdraw/channel/update",
      type: "post",
      params: params,
    });
  },
  // 修改提现税率
  updateTax(params) {
    return ajax({
      url: "/withdraw/channel/batch",
      type: "post",
      params: params,
    });
  },
  // 删除提现方式配置
  delWChannel(params) {
    return ajax({
      url: "/withdraw/channel/delete",
      type: "delete",
      params: params,
    });
  },
  /********************************提现银行配置*********************************** */
  // 提现银行配置列表配置
  cashBankList(params) {
    return ajax({
      url: "/bankType/list",
      type: "get",
      params: params,
    });
  },
  // 提现银行配置新增
  addCashBank(params) {
    return ajax({
      url: "/bankType/add",
      type: "post",
      params: params,
    });
  },
  // 提现银行配置编辑
  editCashBank(params) {
    return ajax({
      url: "/bankType/update",
      type: "post",
      params: params,
    });
  },
  // 提现银行配置删除
  delCashBank(params) {
    return ajax({
      url: "/bankType/del ",
      type: "delete",
      params: params,
    });
  },

  /******************************财务转账列表******************************/
  // 获取财务转账列表
  getTransferList(params) {
    return ajax({
      url: "/withdraw/finan/list",
      type: "get",
      params: params,
    });
  },
  // 回执请求
  receipt(params) {
    return ajax({
      url: "/withdraw/finan/receipt",
      type: "post",
      params: params,
    });
  },

  /******************************退款列表******************************/
  // 获取退款列表
  getRefundList(params) {
    return ajax({
      url: "/withdraw/refund/list",
      type: "get",
      params: params,
    });
  },
  // 请求
  Refund(params) {
    return ajax({
      url: "/withdraw/refund/dealwith ",
      type: "post",
      params: params,
    });
  },
  /******************************积分统计******************************/
  // 查询流水积分
  queryPointList(params) {
    return ajax({
      url: "/point/userlist",
      type: "get",
      params: params,
    });
  },
  // 查询积分每日统计
  queryPointsDailyStatistics(params) {
    return ajax({
      url: "/point/list",
      type: "get",
      params: params,
    });
  },
};
export default transApi;
